// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__336mL","clinicsSelect":"TableHeading_clinicsSelect__2YPOI"};